import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Table, type Column } from "@freightsimple/ui-core/Table/Table";
import { TextCell } from "@freightsimple/ui-core/Cells/TextCell";
import type { OpportunityLane } from "@freightsimple/generated-carriers-openapi-client/models/OpportunityLane";
import { formatPercent } from "@/App/Views/carrierFormatting";

/**
 * The complete lane table.
 *
 * Lanes and origins are the one thing carriers reliably come back about, and
 * the one thing an email can't carry. The dialog shows the busiest few; this
 * shows all of them, because "and 40 more lanes" is exactly the detail a
 * carrier opened the package for.
 */
export function OpportunityLaneTablePanel({
  lanes,
}: {
  lanes: OpportunityLane[];
}) {
  const columns: Column<OpportunityLane>[] = [
    {
      key: "pickup",
      header: "From",
      render: (lane) => <TextCell value={lane.pickup} />,
    },
    {
      key: "delivery",
      header: "To",
      render: (lane) => <TextCell value={lane.delivery} />,
    },
    {
      key: "count",
      header: "Shipments",
      align: "right",
      render: (lane) => (
        <TextCell value={lane.shipmentCount.toLocaleString("en-CA")} />
      ),
    },
    {
      key: "share",
      header: "Share",
      align: "right",
      render: (lane) => (
        <TextCell value={formatPercent(lane.sharePercentage)} color="muted" />
      ),
    },
  ];

  return (
    <Panel title="Every lane" count={lanes.length} fullBleed>
      <Table
        columns={columns}
        data={lanes}
        rowKey={(lane) => `${lane.pickup}|${lane.delivery}`}
        emptyMessage="No lanes recorded in the data window."
        pageSize={25}
      />
    </Panel>
  );
}
